export const STATE_INFO_PREFIX = 'common.state.';

export const stateInfoKey = (state) => (typeof state === 'string' && state ? STATE_INFO_PREFIX + state : '');

export const STATE_LEGEND_INFO_KEY = 'common.states';

export const STATE_LEGEND_LABEL = 'Selos de estado';

export const COMMON_GLOSSARY = [
  {
    key: 'common.state.ok',
    label: 'Medido',
    whatIs: 'O número foi calculado com todos os dias do período já fechados e dentro da cobertura da coleta. É o estado normal e por isso não mostra selo.',
    purpose: 'Indica que o valor é definitivo para o recorte e pode ser comparado com outros períodos e outras telas.',
    howGenerated: 'O PI confere, para cada dia do cálculo, se o fechamento diário já rodou, se o dia está dentro da cobertura da coleta e se não está em recálculo.',
  },
  {
    key: 'common.state.partial',
    label: 'Parcial',
    whatIs: 'O número usa um dia ou uma janela que ainda não fechou: o período inclui hoje, a janela começa antes do início da medição ou o dia está em recálculo.',
    purpose: 'Avisa que o valor é provisório e pode mudar até o fechamento diário; leia como tendência, não como resultado final.',
    howGenerated: 'O PI marca parcial quando algum dia do cálculo ainda não passou pelo fechamento diário, fica antes da cobertura da coleta ou está sendo recalculado.',
    caveat: 'Não compare um número parcial com um período fechado sem levar a diferença em conta.',
    seeAlso: ['common.coverage', 'common.asOf'],
  },
  {
    key: 'common.state.na',
    label: 'n/d',
    whatIs: 'Número não disponível para este recorte. O motivo aparece ao lado do valor ou ao passar o mouse sobre ele.',
    purpose: 'Evita mostrar zero no lugar de "não sei": n/d nunca quer dizer que ninguém usou.',
    howGenerated: 'Aparece quando a combinação de filtros não tem número pré-calculado (mais de um corte ao mesmo tempo), quando uma taxa tem denominador zero ou quando a fonte do dado não cobre o recorte.',
    caveat: 'Para ter o número, aplique um corte por vez: papel do usuário, plataforma, módulo, porte ou perfil da empresa.',
  },
  {
    key: 'common.state.insufficient',
    label: 'Dados insuficientes',
    whatIs: 'A base é pequena demais para um número confiável, por exemplo menos de 30 usuários elegíveis na adoção ou menos de 7 dias de coleta.',
    purpose: 'Impede decisões em cima de porcentagens que mudam muito com uma ou duas pessoas.',
    howGenerated: 'Cada métrica tem um mínimo de base definido no PI; abaixo dele o valor não é mostrado e o selo aparece no lugar.',
  },
  {
    key: 'common.state.immature',
    label: 'Pendente',
    whatIs: 'A coorte (grupo de empresas ou pessoas que começaram no mesmo período) ainda não completou a janela da métrica; o valor sai na data indicada.',
    purpose: 'Evita comparar coortes recentes, ainda em andamento, com coortes que já fecharam a janela.',
    howGenerated: 'O PI só calcula a métrica de uma coorte depois que todos os dias da janela passaram e foram fechados.',
  },
  {
    key: 'common.state.derived',
    label: 'Retroativo',
    whatIs: 'Número calculado a partir do histórico já gravado nos bancos dos clientes, para dias anteriores ao início da coleta de eventos.',
    purpose: 'Dá série histórica para ler tendência antes do início da coleta instrumentada.',
    howGenerated: 'Derivado dos registros do produto (batidas, ajustes, documentos e outros) com uma regra mais simples que a dos eventos coletados ao vivo.',
    caveat: 'É comparável na tendência, mas foi medido de outro jeito: não some com números da coleta ao vivo sem ler a nota.',
    seeAlso: ['common.coverage'],
  },
  {
    key: 'common.state.disabled',
    label: 'Não habilitada',
    whatIs: 'Nenhuma empresa do recorte tem esta funcionalidade liberada no período.',
    purpose: 'Separa "não contratada" de "contratada e não usada": aqui não há base para medir uso.',
    howGenerated: 'Lido do retrato noturno das funcionalidades liberadas em cada empresa, cruzado com o período e os filtros.',
  },
  {
    key: 'common.state.no_eligible',
    label: 'Sem elegíveis',
    whatIs: 'A funcionalidade está liberada, mas nenhum usuário habilitado tem um papel que pode usá-la.',
    purpose: 'Aponta trabalho de implantação: liberar a funcionalidade não basta se ninguém tem o papel certo.',
    howGenerated: 'Cruza as empresas com a funcionalidade liberada, os usuários habilitados e os papéis que a funcionalidade aceita, no retrato de cada dia.',
  },
  {
    key: 'common.state.no_usage',
    label: 'Sem uso',
    whatIs: 'Há usuários elegíveis, mas ninguém usou a funcionalidade no período.',
    purpose: 'É a lista mais direta de oportunidade de ativação: quem pode usar e não usa.',
    howGenerated: 'Elegíveis sem nenhuma ação bem-sucedida da funcionalidade na janela de 30 dias até o último dia fechado do período.',
  },
  {
    key: 'common.state.not_instrumented',
    label: 'Sem medição',
    whatIs: 'Nenhum evento desta funcionalidade é coletado ainda, então o PI não sabe se ela é usada.',
    purpose: 'Evita ler falta de medição como falta de uso.',
    howGenerated: 'Vem do catálogo de eventos do PI: a funcionalidade ainda não tem nenhuma ação ligada a um evento coletado.',
  },
  {
    key: STATE_LEGEND_INFO_KEY,
    label: STATE_LEGEND_LABEL,
    whatIs: 'Selo ao lado do número da célula. Parcial: o período ainda não fechou e o valor pode mudar. n/d: não disponível neste recorte. Dados insuficientes: base pequena demais para um número confiável. Pendente: a coorte ainda não completou a janela.',
    purpose: 'Diz como ler a célula: com selo, o número é provisório, medido de outro jeito ou foi escondido de propósito; sem selo, está medido e fechado. n/d e Dados insuficientes nunca querem dizer zero.',
    howGenerated: 'O PI devolve um estado para cada número conferindo fechamento diário, cobertura da coleta, base mínima e maturação; o motivo aparece ao passar o mouse na célula. Retroativo: calculado do histórico gravado, antes da coleta de eventos.',
    caveat: 'Na adoção de funcionalidades também aparecem Não habilitada (nenhuma empresa liberou), Sem elegíveis (ninguém com o papel certo), Sem uso (elegíveis que não usaram) e Sem medição (evento ainda não coletado).',
    seeAlso: ['common.state.partial', 'common.state.na', 'common.state.insufficient', 'common.state.immature', 'common.state.derived'],
  },
  {
    key: 'common.asOf',
    label: 'Dados de',
    whatIs: 'Data e hora até onde os eventos de uso já foram processados nesta tela. No rodapé aparece como "Atualizado em".',
    purpose: 'Diz quão recente é o número: uma ação feita depois desse horário ainda não aparece.',
    howGenerated: 'É a marca do último processamento dos eventos, que roda a cada 15 minutos, em horário de Brasília. Com vários blocos, o rodapé mostra o horário mais antigo entre eles.',
    caveat: 'O retrato das empresas, dos usuários e das funcionalidades é noturno: mudança de cadastro só aparece no dia seguinte.',
  },
  {
    key: 'common.coverage',
    label: 'Cobertura',
    whatIs: 'Desde quando há dado medido: a data de início da coleta de eventos e, quando houver, desde quando existe histórico retroativo.',
    purpose: 'Mostra até onde dá para olhar para trás: antes dessas datas o número não existe ou foi calculado de outro jeito.',
    howGenerated: 'O início da coleta é a data do primeiro evento recebido; o retroativo é a primeira data recomposta a partir dos registros dos bancos dos clientes.',
    caveat: 'Um período que começa antes da cobertura sai parcial ou vazio, nunca com zero.',
    seeAlso: ['common.state.derived', 'common.state.partial'],
  },
  {
    key: 'common.definitionVersion',
    label: 'Versão da definição',
    whatIs: 'Número da versão da regra de cálculo do indicador, com a data desde quando ela vale.',
    purpose: 'Permite saber se dois números foram calculados pela mesma regra antes de compará-los.',
    howGenerated: 'Cada mudança de regra gera uma versão nova no catálogo de métricas do PI, com o motivo da mudança; a tela mostra a versão em vigor.',
  },
  {
    key: 'common.delta',
    label: 'Variação (Δ)',
    whatIs: 'Diferença entre o valor do período e o do período anterior de mesmo tamanho: absoluta e, entre parênteses, em porcentagem.',
    purpose: 'Mostra a direção e o tamanho da mudança, para priorizar o que de fato subiu ou caiu.',
    howGenerated: 'Valor atual menos o anterior; a porcentagem divide essa diferença pelo valor anterior. Em taxas, a diferença sai em pontos percentuais (p.p.). Só aparece com "Comparar" ligado.',
    caveat: 'Sem valor anterior, ou com valor anterior zero, a porcentagem não aparece.',
    seeAlso: ['filter.compare'],
  },
  {
    key: 'common.trend',
    label: 'Tendência',
    whatIs: 'Minigráfico com a evolução do número ao longo do período, para ver o formato da curva sem abrir outra tela.',
    purpose: 'Separa queda pontual de queda contínua e mostra se a variação veio de poucos dias.',
    howGenerated: 'Usa a mesma regra da coluna ao lado, calculada em pontos ao longo do período (por semana nas listas de empresas).',
    caveat: 'A tendência não vai na exportação; para a série completa, use a tela de Engajamento.',
  },
  {
    key: 'common.universe',
    label: 'Universo ativo',
    whatIs: 'Conjunto de empresas que entram nos números: ativas, não excluídas, fora das marcadas como demonstração e fora do ambiente de Portugal. Trial e grátis entram.',
    purpose: 'Garante que todos os números falam das mesmas empresas e que empresas nossas não inflam o uso.',
    howGenerated: 'Recalculado por dia a partir do retrato noturno das empresas de cada banco. Operações e retenção incluem também as empresas inativas.',
    caveat: 'Mudança de cadastro só entra no retrato da noite seguinte.',
    seeAlso: ['common.demo'],
  },
  {
    key: 'common.company',
    label: 'Empresa',
    whatIs: 'Nome da empresa no cadastro, com o código do banco de dados em que ela está.',
    purpose: 'Identifica a conta. O nome abre o detalhe da empresa no PI com o mesmo período e os mesmos filtros; clique do meio abre em outra aba.',
    howGenerated: 'Nome lido do retrato noturno do cadastro da empresa no banco dela.',
    seeAlso: ['common.shard', 'common.companyId'],
  },
  {
    key: 'common.companyId',
    label: 'Identificador da empresa',
    whatIs: 'Código único da empresa no sistema, o mesmo usado pela conta no Master.',
    purpose: 'Cruza a planilha com outras bases e localiza a empresa sem depender do nome.',
    howGenerated: 'Vem do cadastro da empresa, lido no retrato noturno de cada banco.',
  },
  {
    key: 'common.shard',
    label: 'Banco',
    whatIs: 'Código de 4 letras do banco de dados em que a empresa está, como AAAA ou NNNN.',
    purpose: 'Junto com o identificador, localiza a empresa sem ambiguidade e ajuda a investigar um problema que atinge um banco só.',
    howGenerated: 'Vem do contexto da empresa no cadastro, gravado no retrato noturno.',
  },
  {
    key: 'common.sizeBand',
    label: 'Porte',
    whatIs: 'Faixa de tamanho pelo número de funcionários informado no cadastro: A (100 ou mais), B (50 a 99), C (21 a 49), D (11 a 20) e E (até 10).',
    purpose: 'Compara a empresa com outras de tamanho parecido.',
    howGenerated: 'Calculado no retrato noturno a partir do total de funcionários do cadastro da empresa, e não dos usuários habilitados.',
    caveat: 'Não confunda com o perfil da empresa, que usa as mesmas letras com outra régua.',
    seeAlso: ['common.segment'],
  },
  {
    key: 'common.segment',
    label: 'Perfil da empresa',
    whatIs: 'Categoria comercial de A a E gravada no Master, o "Perfil" do detalhe da empresa.',
    purpose: 'Mostra a categoria que o comercial e o time de sucesso do cliente usam para priorizar a conta.',
    howGenerated: 'Lido do detalhe da empresa no Master. A régua padrão é pelo número de funcionários (E até 10, D de 11 a 30, C de 31 a 50, B acima de 50); A e as exceções são escolhas manuais.',
    caveat: 'Empresa sem perfil gravado aparece sem perfil. Não confunda com o porte.',
    seeAlso: ['common.sizeBand'],
  },
  {
    key: 'common.journey',
    label: 'Jornada',
    whatIs: 'Etapa da empresa na jornada do cliente gravada no Master: Lead, Onboarding, Middle, Ongoing ou Resale.',
    purpose: 'Cruza a etapa que o time registrou com o uso real medido pelo PI.',
    howGenerated: 'Lida do cadastro da empresa no retrato noturno. É informativa: o PI não calcula a jornada, só mostra o que o time gravou.',
    caveat: 'Depende de atualização manual e pode estar desatualizada; confira com a última atividade.',
  },
  {
    key: 'common.companyStatus',
    label: 'Situação',
    whatIs: 'Estado da empresa no cadastro: Ativa, Trial, Expirada (trial vencido), Inativa, Bloqueada ou Cancelada.',
    purpose: 'Separa conta ativa de conta em teste, bloqueada ou cancelada ao ler o uso.',
    howGenerated: 'Do retrato noturno: ativa sem trial é Ativa; ativa em trial é Trial, ou Expirada se o vencimento passou; inativa é Cancelada ou Bloqueada conforme o status do cadastro, senão Inativa.',
    caveat: 'Não decide quem entra no universo: isso depende só de estar ativa e não excluída.',
    seeAlso: ['common.universe'],
  },
  {
    key: 'common.lastActivity',
    label: 'Última atividade',
    whatIs: 'Último dia do período em que alguém da empresa concluiu uma ação de uso real; com o filtro de papel, alguém daquele papel.',
    purpose: 'Mostra há quanto tempo a conta está parada e ajuda a priorizar o contato com quem sumiu.',
    howGenerated: 'Maior dia, dentro do período, com pelo menos um usuário ativo nos agregados diários do PI, no dia local da empresa.',
    caveat: 'Só abrir o sistema não conta como atividade.',
  },
  {
    key: 'common.activeUsers30d',
    label: 'Ativos (30 dias)',
    whatIs: 'Pessoas distintas da empresa que concluíram pelo menos uma ação de uso real nos 30 dias até o último dia fechado do período.',
    purpose: 'Mede o uso real da conta; é a base do Active Seats Rate e do sinal de queda de atividade.',
    howGenerated: 'Ativo é quem concluiu ação marcada como uso real no catálogo (bater ponto, ajuste, aprovação, férias, espelho, documento). Janela móvel de 30 dias, a mesma dos ativos no mês (MAU).',
    caveat: 'Empresa fora do universo ativo mostra "—" com o motivo.',
    seeAlso: ['common.enabledUsers', 'common.activeSeatsRate'],
  },
  {
    key: 'common.enabledUsers',
    label: 'Habilitados',
    whatIs: 'Usuários ativos e não excluídos da empresa, com papel de funcionário, gestor, admin ou contador.',
    purpose: 'É a base cadastrada que poderia usar o produto e o denominador do Active Seats Rate.',
    howGenerated: 'Contados no retrato noturno do cadastro de usuários, no dia de referência do número.',
    caveat: 'Não é o número de funcionários do cadastro da empresa, que só define o porte.',
  },
  {
    key: 'common.activeSeatsRate',
    label: 'Active Seats Rate',
    whatIs: 'Taxa de assentos ativos: parte dos usuários habilitados que foi ativa nos 30 dias até o último dia fechado do período.',
    purpose: 'Mede quanto da base cadastrada usa de verdade; taxa baixa é risco de cancelamento ou de redução do contrato.',
    howGenerated: 'Ativos em 30 dias que estão habilitados, divididos pelos habilitados, vezes 100, no dia de referência.',
    caveat: 'Com filtro de plataforma ou módulo, o denominador é o total de habilitados. Se o numerador passar do denominador, sai n/d.',
    metricKey: 'active_seats_rate',
    seeAlso: ['common.activeUsers30d', 'common.enabledUsers'],
  },
  {
    key: 'common.contractUtilization',
    label: 'Utilização do contrato',
    whatIs: 'Ativos habilitados em 30 dias divididos pelos assentos da assinatura ativa da empresa.',
    purpose: 'Compara o uso com o que foi vendido: abaixo de 50% é risco; acima de 100% é chance de venda adicional.',
    howGenerated: 'Ativos habilitados nos 30 dias até o último dia fechado, divididos pelos assentos contratados (máximo de funcionários do contrato), vezes 100.',
    caveat: 'Pode passar de 100%. Sai n/d sem assinatura ativa e com filtro de plataforma ou módulo.',
    metricKey: 'contract_utilization',
    seeAlso: ['common.seatsContracted'],
  },
  {
    key: 'common.seatsContracted',
    label: 'Assentos contratados',
    whatIs: 'Número máximo de funcionários previsto no contrato da assinatura ativa da empresa.',
    purpose: 'É o tamanho vendido da conta, para comparar com os habilitados e os ativos.',
    howGenerated: 'Lido da assinatura ativa no retrato noturno de cada banco.',
  },
  {
    key: 'common.signalDrop',
    label: 'Queda de atividade',
    whatIs: 'Selo da empresa cujos ativos em 30 dias caíram para 70% ou menos do mesmo número no período anterior, com base de pelo menos 10 ativos.',
    purpose: 'Sinaliza risco de cancelamento para o time de sucesso do cliente agir cedo.',
    howGenerated: 'Compara os ativos dos 30 dias até o último dia fechado do período com os 30 dias até o último dia fechado do período anterior, de mesmo tamanho.',
    caveat: 'Empresa sem uso no período nunca é tratada como cancelada.',
    seeAlso: ['common.activeUsers30d'],
  },
  {
    key: 'common.demo',
    label: 'Demonstração',
    whatIs: 'Empresa nossa (demonstração, interna ou teste), marcada no detalhe da empresa para ficar fora dos números do PI e dos relatórios do Master.',
    purpose: 'Mantém os números limpos: empresa de demonstração nunca entra em uso, adoção, coortes nem oportunidades.',
    howGenerated: 'A marca é gravada no cadastro da empresa ("oculta dos relatórios"), com motivo e autor; o PI aplica a marca em todo o histórico na madrugada seguinte.',
    caveat: 'Desmarcar devolve a empresa aos números, também no histórico; o recálculo leva uma madrugada.',
    seeAlso: ['common.universe'],
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/common.js